import { render, staticRenderFns } from "./FormAlertTipp.vue?vue&type=template&id=5ca2731a"
import script from "./FormAlertTipp.vue?vue&type=script&lang=ts"
export * from "./FormAlertTipp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports